export default Object.freeze({
  TITLE: '상품 재입고 알림 신청 관리',
  ADVENCED_SEARCH: '상세검색',
  OPTION_PRODUCT_NO: '상품번호',
  OPTION_MANAGE_CODE: '옵션관리코드',
  OPTION_STOCK_NO: '재고번호',
  OPTION_NO: '옵션번호',
  OPTION_MALL_ALL: '쇼핑몰 전체',
  OPTION_ALIGN_STANDARD: '정렬기준',
  OPTION_ALIGN_DESC: '최근등록순',
  OPTION_ALIGN_CNT_DESC: '신청내역순',
  OPTION_ALIGN_NOT_SEND_CNT_DESC: '미발송수순',
  REQUEST: '신청',
  NOT_YET_SEND: '미발송',
  TOOL_TIP_DESC1: '상품 또는 옵션이 삭제된 경우 회색으로 색상이 구분됩니다.',
  TOOL_TIP_DESC2: '발송 완료하여 수집목적을 달성한 경우, 해당 내역 삭제 처리하시길 권장합니다.',
  TOOL_TIP_DESC3: '신청 이후 6개월 경과 시 해당 내역은 자동으로 삭제 처리되니 유의하시길 바랍니다.',
  TOOL_TIP_DESC4: '· 발송 완료하여 수집목적을 달성한 경우, 해당 내역 삭제 처리하시길 권장합니다.',
  TOOL_TIP_DESC5: '· 신청 이후 6개월 경과 시 해당 내역은 자동으로 삭제 처리되니 유의하시길 바랍니다.',
  TOOL_TIP_DESC6: '· 발송요청 시 발송여부가 발송으로 변경됩니다. (요청 후 수신 실패될 수 있으며, 상세 내역은 ',
  TOOL_TIP_DESC6_1: '에서 확인 가능)',
  BTN_SELECTED_DELETE: '선택 삭제',
  TABLE_HEADER_PARTNER: '파트너사',
  TABLE_HEADER_PRODUCT_NO: '상품번호',
  TABLE_HEADER_PRODUCT_NAME: '상품명',
  TABLE_HEADER_OPTION_NO: '옵션번호',
  TABLE_HEADER_OPTION_NAME_AND_VALUE: '옵션명:옵션',
  TABLE_HEADER_REQUEST_USER: '신청자',
  TABLE_HEADER_REQ_USER_LIST: '신청자 리스트',
  TABLE_HEADER_RESERVATION_INVENTORY: '예약재고',
  TABLE_HEADER_INVENTORY: '재고',
  TABLE_HEADER_SALES_STATUS: '판매상태',
  TABLE_HEADER_SALES_SETUP: '판매설정',
  TABLE_HEADER_OPTION_AVAILABILITY: '옵션사용여부',
  TABLE_HEADER_PRE_SALE_PERIOD: '예약판매기간',
  TABLE_HEADER_SALE_PERIOD: '판매기간',
  TABLE_HEADER_EXHIBIT_STATUS: '전시상태',
  TABLE_HEADER_DATE_OF_APPLICATION: '신청일시',
  TABLE_HEADER_PHONE: '휴대폰번호',
  TITLE_DETAIL: '상품 재입고 알림 신청 내역',
  PRODUCT_INFO: '상품 정보',
  SEND_OR_NOT: '발송여부',
  SEND: '발송',
  CONFIRM_OPTION_DELETE: '신청내역 삭제 시 해당 옵션의 상세 신청 내역 전체가 \n삭제되며, 삭제 시 복구가 불가합니다.\n' +
      '선택한 옵션의 알림 신청내역을 정말 삭제하시겠습니까?\n',
  MAX_KEYWORD: '검색어는 최대 20개까지 입력 가능합니다.',
  MAX_CHAR: '검색어는 최대 1000자까지 입력 가능합니다.',
  ON_SALE: '판매중',
  PRE_APPROVAL_STATUS: '승인완료 이전',
  WAITING_PRE_SALE: '예약판매대기',
  ON_PRE_SALE: '예약판매중',
  WAITING_SALE: '판매대기',
  END_SALE: '판매종료',
  AVAILABLE_FOR_SALE: '판매가능',
  STOP_SELLING: '판매중지',
  PROHIBITION_SALE: '판매금지',
  CAN_DISPLAY: '전시가능',
  CAN_NOT_DISPLAY: '전시안함',
  ALERT_SELECT_ROW: '내역을 선택해주세요.',
  CONFIRM_RESTOCK_RESULT_DELETE: '신청 내역 삭제 시 복구가 불가능합니다.\n 선택한 알림 신청내역을 정말 삭제하시겠습니까?',
  ALERT_SMS_SETTING: '쇼핑몰의 SMS 발송 설정을 사용함으로 설정하고\n 발신번호를 등록하여야 SMS 발송이 가능합니다.',
  CONFIRM_SMS_SEND: '발송여부가 \'미발송\'인 신청자 전체를 대상으로 알림이 발송됩니다.\n선택된 내역이 아닌 전체 내역을 기준으로 발송되며,\n발송여부가 \'발송\'인 신청자는 대상에 포함되지 않습니다.\n알림을 발송하시겠습니까?',
  SMS_TXT: '이(가) 입고되었습니다.',
  DELETED_OPTION: '삭제된 옵션입니다.',
  DELETED_PRODUCT: '완전 삭제된 상품입니다.',
  ALERT_EMPTY_UN_SENT_MEMBER: '발송여부가 \'미발송\'인 신청자가 존재하지 않습니다.'
});